import { ActionType } from "../action-types";
import { Action } from "../actions";
import { RolesDto } from "../../dto/roles";

export type RolesState = RolesDto[];

const initialState: RolesState = [];

const rolesReducer = (
  state: RolesState = initialState,
  action: Action
): RolesState => {
  switch (action.type) {
    case ActionType.SET_ROLES:
      return action.payload;
    default:
      return state;
  }
};

export default rolesReducer;
